//@import dependencies
import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import { Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//@end

//@import components
import IconComponent from 'app_components/commons/icons'
//@end

// @import hooks
import {useColors} from 'app_hooks/useColors'
// @end

// @INFO Import types
// @end

// @INFO Import services
import DurationFieldService from 'app_services/components/durationFieldService';
// @end

// @INFO Import Styles
import './../modalCourseSchedulingSessionFormModule.scss'

// @ADD Component types
interface IModalCourseSchedulingSessionFormModuleLayoutProps {
  open          : boolean
  processing    : boolean
  customErrors? : any
  editData?     : any
  handleClose   : (data:any)=>void
  onHandleSubmit: (data: any) => void
  minDate?: string
  endDate?: string
}

const ModalCourseSchedulingSessionFormModuleLayout: React.FC<IModalCourseSchedulingSessionFormModuleLayoutProps> = (props) => {

  // @INFO: Services
  const durationFieldService: DurationFieldService = new DurationFieldService()

  const [colors] = useColors()

  const {open} = props

  const formHook = useForm()
  const { t } = useTranslation()

  const [reinforcement_class, setReinforcementClass] = useState<boolean>(false)
  const [hasChanges, setHasChanges] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<any>(props.minDate ? new Date(`${props.minDate}T00:00:00`) : new Date());

  const handleStartDateChange = (date: any) => {
    setStartDate(date)
  }

  const handleCloseModal = (data: any) => {
    props.handleClose(data)
  }

  const handleChangeReinforcementClass = (e: any) => {
    setReinforcementClass(!reinforcement_class)
    setHasChanges(true);
  }

  useEffect(() => {
    if (props?.editData) {
      if (props?.editData?.startDate) {
        setStartDate(new Date(props?.editData?.startDate))
      }
      if (props?.editData?.reinforcement_class) {
        setReinforcementClass(true)
      }
    }
  }, [props,props.editData])

  return(
    <div className=''>
      <Modal show={open} onHide={() => handleCloseModal({ status: false })} className="modal_course_scheduling_session_form-component">
        <Modal.Header>
          <Modal.Title>
            {t('modules.modal_course_scheduling_session_form.title')}
          </Modal.Title>
          <div className="close-button" onClick={() => handleCloseModal({status: false})}>
            <IconComponent
              color={colors.secondary}
              width='1.5rem'
              height='1.5rem'
              fontawesome={{
                icon: 'fas fa-times-circle',
              }}
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formHook.handleSubmit(props.onHandleSubmit)}>

            <input type="hidden" name="hasChanges" value={hasChanges ? 'on' : 'off'} ref={formHook.register({ required: false })}/>
            {props?.editData?.uuid && (
              <input
                type="hidden"
                name="uuid"
                defaultValue={props?.editData?.uuid}
                ref={formHook.register({ required: true })}
              />
            )}

            <div className="col-md-12">
              <div className="form-group">
                <Form.Check
                  type='switch'
                  id='reinforcement_class'
                  name='reinforcement_class'
                  label={t('labels.modal_course_scheduling_session_form.reinforcement_class')}
                  onChange={(event: any) => handleChangeReinforcementClass(event)}
                  checked={reinforcement_class}
                  ref={formHook.register()}
                  disabled={props?.editData}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group start-date-input">
                <label htmlFor='startDate'>{t('labels.modal_course_scheduling_session_form.startDate')}</label>
                <input
                  type="hidden"
                  name="startDate"
                  defaultValue={moment(startDate).format('YYYY-MM-DD HH:mm')}
                  ref={formHook.register({ required: true })}
                />
                <DatePicker
                  selected={startDate}
                  onChange={(date) => {
                    handleStartDateChange(date);
                    setHasChanges(true);
                  }}
                  showTimeSelect
                  dateFormat="MM/dd/yyyy h:mm aa"
                  timeIntervals={15}
                  timeCaption="Hora"
                  minDate={props.minDate ? new Date(`${props.minDate}T00:00:00`) : undefined}
                  maxDate={props.endDate ? new Date(`${props.endDate}T00:00:00`) : undefined}
                />
                {/* <input
                  type='datetime-local'
                  className='form-control'
                  name='startDate'
                  defaultValue={moment.utc(props?.editData?.startDate).format('YYYY-MM-DD') || moment.utc().format('YYYY-MM-DD')}
                  ref={formHook.register({ required: true })}
                /> */}
                {formHook.errors.startDate && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='duration'>{t('labels.modal_course_scheduling_session_form.duration')}</label>
                {formHook.errors.duration && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='duration'
                  name='duration'
                  className={`form-control ${formHook.errors.duration && 'is-invalid'}`}
                  type='text'
                  placeholder='0h 0m 0s'
                  ref={formHook.register({ required: true })}
                  defaultValue={(props?.editData?.duration) ? durationFieldService.getDurationFormated(props?.editData?.duration, 'short', false) : ''}
                  onChange={() => setHasChanges(true)}
                />
              </div>
              {props.customErrors?.duration_invalid && <div className='custom-invalid-feedback'>{props.customErrors?.duration_invalid}</div>}
            </div>

            <div className='buttons-group'>
              <div className='text-center'>
                <button className='btn btn-secondary' type='submit' disabled={props.processing}>
                  {props.processing && (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;</>)}
                  {t('modules.modal_course_scheduling_session_form.form.save')}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ModalCourseSchedulingSessionFormModuleLayout
